package com.klantenstop.web.components

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.klantenstop.web.auth.AuthModule
import com.klantenstop.web.navigation.Navigation
import com.klantenstop.web.navigation.SectionItem
import com.klantenstop.web.navigation.logout
import com.materialkobweb.styles.MaterialColorVars
import com.klantenstop.web.utils.logoImage
import com.klantenstop.web.utils.withAlpha
import com.materialkobweb.components.sections.BaseHeader
import com.materialkobweb.components.sections.NavigationItem
import com.materialkobweb.components.widgets.DsMaterialSymbols
import com.materialkobweb.components.widgets.DsSpinner
import com.materialkobweb.components.widgets.IconButton
import com.materialkobweb.components.widgets.MaterialSymbolType
import com.materialkobweb.components.widgets.OutlinedButtonLink
import com.materialkobweb.components.widgets.SpinnerSize
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.UserSelect
import com.varabyte.kobweb.compose.css.functions.LinearGradient
import com.varabyte.kobweb.compose.css.functions.linearGradient
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.backgroundImage
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.boxShadow
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.position
import com.varabyte.kobweb.compose.ui.modifiers.right
import com.varabyte.kobweb.compose.ui.modifiers.top
import com.varabyte.kobweb.compose.ui.modifiers.userSelect
import com.varabyte.kobweb.compose.ui.modifiers.widthIn
import com.varabyte.kobweb.compose.ui.modifiers.zIndex
import com.varabyte.kobweb.compose.ui.thenIf
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.layout.HorizontalDivider
import com.varabyte.kobweb.silk.components.navigation.Link
import com.varabyte.kobweb.silk.components.navigation.UndecoratedLinkVariant
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.breakpoint.displayIfAtLeast
import com.varabyte.kobweb.silk.style.breakpoint.displayUntil
import com.varabyte.kobweb.silk.style.extendedBy
import com.varabyte.kobweb.silk.style.selectors.hover
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import kotlinx.browser.document
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.css.px

@Composable
fun LandingHeader(
    showMenu: Boolean = true,
    onMenuClicked: () -> Unit
) {
    val authStatus = AuthModule.authStatus.collectAsState()
    val isAuthenticated = authStatus.value?.authenticated
    var isMenuOpen by remember { mutableStateOf(false) }
    val ctx = com.varabyte.kobweb.core.rememberPageContext()

    BaseHeader(
        modifier = Modifier
            .padding(leftRight = 24.px)
            .backgroundImage(
                linearGradient(
                    MaterialColorVars.Background.value(),
                    MaterialColorVars.Background.withAlpha(0.6f),
                    LinearGradient.Direction.ToBottom
                )
            )
    ) {
        Row(
            modifier = Modifier.fillMaxWidth(),
            horizontalArrangement = Arrangement.SpaceBetween,
            verticalAlignment = Alignment.CenterVertically
        ) {
            LeftSide(showMenu, onMenuClicked)

            if (showMenu) {
                Row(
                    modifier = Modifier.displayIfAtLeast(Breakpoint.LG).margin(right = 30.px),
                    horizontalArrangement = Arrangement.spacedBy(30.px, Alignment.End),
                    content = { NavigationItems() }
                )
            }
        }

        when (isAuthenticated) {
            null -> DsSpinner(
                modifier = Modifier.margin(10.px),
                size = SpinnerSize.Small
            )

            true -> Box(
                modifier = Modifier.position(Position.Relative) // anchor
            ) {
                IconButton(
                    onClick = { isMenuOpen = !isMenuOpen }
                ) {
                    DsMaterialSymbols(icon = "account_circle")
                }

                if (isMenuOpen) {
                    UserMenu(onDismiss = { isMenuOpen = false })
                }
            }

            false -> OutlinedButtonLink(
                path = Navigation.Screen.Login(
                    returnTo = ctx.route.pathQueryAndFragment.takeIf { it != "/" }
                ).route
            ) {
                SpanText("Login")
            }
        }
    }
}

@Composable
private fun LeftSide(
    showMenu: Boolean,
    onMenuClicked: () -> Unit
) {
    Row(
        horizontalArrangement = Arrangement.spacedBy(24.px),
        verticalAlignment = Alignment.CenterVertically
    ) {
        if (showMenu) {
            IconButton(
                modifier = Modifier.displayUntil(Breakpoint.LG),
                onClick = onMenuClicked
            ) {
                DsMaterialSymbols(
                    icon = "menu",
                    color = MaterialColorVars.OnBackground.value()
                )
            }
        }

        Link(
            path = Navigation.Screen.Home.route,
            variant = UndecoratedLinkVariant
        ) {
            Box(contentAlignment = Alignment.Center) {
                Image(
                    modifier = Modifier.height(40.px),
                    src = logoImage(ColorMode.current),
                    alt = "Logo Image"
                )
            }
        }
    }
}


@Composable
fun NavigationItems(
    isFooterItems: Boolean = false,
    onNavigationItemClicked: (SectionItem) -> Unit = {}
) {
    val linkStyle = Modifier.thenIf(isFooterItems) { Modifier.fontSize(12.px) }

    val sections = listOf(
        SectionItem("home", "Home", Navigation.Screen.Home.route),
        SectionItem("patientenstop", "Patiëntenstop", Navigation.Screen.PatientStopWaitlist.route),
        SectionItem("about", "Over Ons", Navigation.Screen.About.route),
        SectionItem("contact", "Contact", Navigation.Screen.Contact.route),
    )

    sections.forEach {
        NavigationItem(
            modifier = linkStyle,
            href = it.path,
            title = it.title
        ) {
            onNavigationItemClicked(it)
        }
    }
}

const val POP_OVER_Z_INDEX = 9999
const val POP_OVER_ALPHA = 0.15f

@Composable
private fun UserMenu(
    onDismiss: () -> Unit
) {
    // click outside to close
    LaunchedEffect(Unit) {
        document.addEventListener("click", {
            onDismiss()
        }, true)
    }

    Column(
        modifier = Modifier
            .position(Position.Absolute)
            .top(40.px)
            .right(0.px)
            .backgroundColor(MaterialColorVars.SurfaceContainer.value())
            .borderRadius(6.px)
            .boxShadow(0.px, 4.px, 12.px, 0.px, Color.rgba(0, 0, 0, POP_OVER_ALPHA))
            .padding(topBottom = 8.px)
            .zIndex(POP_OVER_Z_INDEX),
        horizontalAlignment = Alignment.End
    ) {
        MenuItem("Profile", Navigation.Screen.Profile.route, icon = "account_circle")
        MenuItem("Settings", Navigation.Screen.Settings.route, icon = "settings")

        HorizontalDivider(modifier = Modifier.fillMaxWidth())

        if (AuthModule.isModerator() || AuthModule.isAdmin()) {
            MenuItem("Admin", Navigation.Screen.Admin.Home.route, icon = "shield_person")

            HorizontalDivider(modifier = Modifier.fillMaxWidth())
        }

        MenuItem("Log out", icon = "logout", onClick = { logout(false) })
    }
}

@Composable
private fun MenuItem(
    label: String,
    href: String? = null,
    icon: String,
    onClick: () -> Unit = {}
) {
    Link(
        modifier = Modifier
            .fillMaxWidth()
            .userSelect(UserSelect.None),
        path = href ?: "",
        variant = ExtendedUndecoratedLinkVariant,
    ) {
        Row(
            modifier = Modifier
                .fillMaxWidth()
                .widthIn(200.px)
                .padding(topBottom = 6.px, leftRight = 16.px)
                .cursor(Cursor.Pointer)
                .onClick {
                    onClick()
                },
            horizontalArrangement = Arrangement.spacedBy(8.px),
            verticalAlignment = Alignment.CenterVertically
        ) {
            DsMaterialSymbols(
                modifier = Modifier.fontSize(20.px),
                type = MaterialSymbolType.Rounded,
                icon = icon
            )

            SpanText(
                text = label,
                modifier = Modifier.fillMaxWidth()
            )
        }
    }
}

val ExtendedUndecoratedLinkVariant = UndecoratedLinkVariant.extendedBy {
    hover {
        Modifier.backgroundColor(MaterialColorVars.SurfaceContainerHighest.value())
    }
}
